module.exports = __webpack_public_path__ + "static/media/food3.1dd4b56d.jpg";